<template>
    <div
        v-if="wishlist?.meta"
        :class="classes"
    >
        <section class="wedding-header-block">
            <h4>- {{ title }} -</h4>
            <h1 class="mt-3" v-html="names"></h1>
            <h3>{{ formattedDate }} &bull; {{ wishlist.location }}</h3>
        </section>
        <div v-if="!isPublic" class="public-link-block">
            <a class="public-link" :href="shareLink">{{ $t('wishlist.seePublicPage') }}</a>
        </div>
    </div>
</template>
<script>
import { defineComponent, unref } from 'vue';
import MainWithAside from '@components/Account/MainWithAside.vue';
import WishlistDetails from '@components/Wishlist/WishlistDetails.vue';
import PageTitle from '@components/Typography/PageTitle.vue';
import { useAppStore } from '@stores/App';
import { useWishlistStore } from '@stores/Wishlist';

export default defineComponent({
    components: { PageTitle, MainWithAside, WishlistDetails },
    props: {
        wishlist: null,
        isPublic: Boolean,
    },
    computed: {
        classes() {
            const app = useAppStore();
            return ['wedding-header', unref(app.getBreakpoints().active())];
        },
        title() {
            return this.wishlist?.name;
        },
        names() {
            const and = '&' || this.$t('wishlist.and');

            const p1 = this.wishlist?.meta.person1;
            const p2 = this.wishlist?.meta.person2;

            const p1Name = `${p1?.firstName} ${p1?.lastName}`.toUpperCase();
            const p2Name = `${p2?.firstName} ${p2?.lastName}`.toUpperCase();

            if (p1 && p2) {
                return `${p1Name} <i>${and}</i> ${p2Name}`;
            }

            return this.wishlist?.name || '(not set)';
        },
        shareLink() {
            const wishlist = useWishlistStore();
            return wishlist.getShareLink(this.wishlist?.uuid);
        },
        formattedDate() {
            const formatter = new Intl.DateTimeFormat('sv-SE', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            });

            if (!this.wishlist?.date) {
                return null;
            }

            try {
                return formatter.format(new Date(this.wishlist?.date));
            } catch (e) {
                return this.$t('form.invalidDate');
            }
        }
    },
});
</script>
<style lang="scss" scoped>
.wedding-header {
    margin-bottom: 2rem;
    &.sm {
        ::v-deep(i) {
            display: block;
        }
    }
}

.wedding-header-block {
    text-align: center;
    padding: 3rem 2rem;
    color: #000000;
    background: #dff2f0;
    position: relative;

    &:before {
        left: 0;
        right: 0;
        width: 100%;
        bottom: -41px;
        height: 123px;
        content: "";
        z-index: 1;
        position: absolute;
        background-size: auto 100%;
        background-image: url(/images/content/wedding-flower-decor.png);
        background-repeat: no-repeat;
        background-position: center bottom;
    }

    h1 {
        font-size: 2rem;
        font-weight: 300;
        font-family: Chronicle, serif;
        i {
            margin: 0 0.5rem;
        }
    }

    h3 {
        font-size: 20px;
        font-weight: 300;
        font-family: Chronicle, serif;
        margin-bottom: 3rem;
        margin-top: 2rem;
    }

    h4 {
        font-size: 16px;
        font-weight: 300;
        font-family: Chronicle, serif;
        text-transform: uppercase;
    }
}

.public-link-block {
    display: flex;
    font-size: 12px;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    margin-top: 2rem;
}

.public-link {
    display: flex;
    text-transform: uppercase;
    text-decoration: underline;
}
</style>
